import { HttpClient } from '@angular/common/http'
import { Inject, Injectable, inject } from '@angular/core'
import {
    BABOOR_ENVIRONMENT,
    BaboorEnvironmentConfig,
} from '@baboor/baboor-core'
import { SubmitOnboarding } from '@baboor/baboor-models'
import { ApiResponse } from '@baboor/common-models'
import { Observable } from 'rxjs'

export type OnboardingSubmitPayload = SubmitOnboarding

export interface OnboardingSubmitResponse {
    shopId: string
    groupId: string
    onboardingCompleted: boolean
}

export interface OnboardingStatusResponse {
    onboardingCompleted: boolean
    currentStep?: number
}

@Injectable({ providedIn: 'root' })
export class OnboardingApiService {
    private http = inject(HttpClient)

    constructor(
        @Inject(BABOOR_ENVIRONMENT)
        private env: BaboorEnvironmentConfig,
    ) {}

    submit(
        data: OnboardingSubmitPayload,
    ): Observable<ApiResponse<OnboardingSubmitResponse>> {
        return this.http.post<ApiResponse<OnboardingSubmitResponse>>(
            `${this.env.apiUrl}/v1/onboarding/submit`,
            data,
        )
    }

    getStatus(): Observable<ApiResponse<OnboardingStatusResponse>> {
        return this.http.get<ApiResponse<OnboardingStatusResponse>>(
            `${this.env.apiUrl}/v1/onboarding/status`,
        )
    }

    geocode(params: {
        address?: string
        city?: string
        state?: string
        postalCode?: string
        country?: string
    }): Observable<
        ApiResponse<{
            latitude: number
            longitude: number
            displayName?: string
        } | null>
    > {
        return this.http.post<
            ApiResponse<{
                latitude: number
                longitude: number
                displayName?: string
            } | null>
        >(`${this.env.apiUrl}/v1/onboarding/geocode`, params)
    }
}
